import { createSlice } from "@reduxjs/toolkit";

const getLoggedinUser = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const user = window.localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};

interface AuthState {
  user: any;
}

const initialUser = getLoggedinUser();

const initialState: AuthState = {
  user: initialUser?.user ?? null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action) {
      state.user = action.payload.user;
    },
    clearToken(state) {
      state.user = null;
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
